import React, { useEffect } from 'react'
import { withTranslation } from "react-i18next";
import { TbInfoTriangle } from "react-icons/tb";
import infoimg from "../../../assets/images/all/infoimg.svg";
import { url } from '../../../helpers/global_helper';

const PlayerBlockPopup = (props) => {
  
  useEffect(() => {

    localStorage.removeItem(url.TOKEN_KEY); 
    localStorage.removeItem('partner_token');

    const timer = setTimeout(() => {
      
      window.location.href = `${window.location.origin}/logout`;
    }, 2000);

    return () => clearTimeout(timer);
  }, []);


  return (
    <div className='block_user'>
      <div className='information-img'>
        <h2>{props.t('information')}</h2>
        <TbInfoTriangle className="info-icon"/>
        <p>{props.t('player_block', {defaultValue:"Mohon maaf, anda tidak diizinkan melakukan akses ke dalam permainan"})}</p>
      </div>
    </div>
  );
}

export default withTranslation()(PlayerBlockPopup);
